import JsxHelper from '../../../Helpers/JsxHelper';
import stringHelper from '../../../Helpers/stringHelper';
import TpJobItem from './TpJobItem';

export default class ExcludedTpJobItem extends TpJobItem {
  static FieldsToShowInDataTable() {
    return [
      {
        label: TpJobItem.getSelectedCellHeader,
        orderById: '',
        data: TpJobItem.getSelectedCellContent,
        minWidth: 20,
        rolekey: 'project_edit',
      },
      { label: 'Third Party Job ID', orderById: 'ThirdPartyJobId', data: TpJobItem.idFunction },
      {
        label: 'Source',
        orderById: 'ThirdPartySource',
        data: 'ThirdPartySource',
        minWidth: 50,
      },
      {
        label: 'Location',
        orderById: 'ThirdPartyLocationName',
        data: 'ThirdPartyLocationName',
        minWidth: 50,
      },
      {
        label: 'Campaign',
        orderById: 'CampaignName',
        data: 'CampaignName',
        minWidth: 50,
      },
      {
        label: 'Eval Fee Total',
        orderById: 'EvaluatorFee',
        data: (item) =>
          stringHelper.getValueWithSymbol(
            '',
            item.EvaluatorCurrencySymbol,
            (TpJobItem.getFeeAmount(item.EvaluatorFee) ?? 0) +
              (TpJobItem.getFeeAmount(item.EvaluatorFeeAdjustment) ?? 0)
          ),
        minWidth: 80,
      },
      {
        label: 'Eval Reimb. Total',
        orderById: 'EvaluatorReimbursement',
        data: (item) =>
          stringHelper.getValueWithSymbol(
            '',
            item.ReimbursementCurrencySymbol,
            TpJobItem.getFeeAmount(item.EvaluatorReimbursement)
          ),
        minWidth: 80,
      },
      {
        label: 'Fieldwork Office',
        orderById: 'FieldworkOfficeName',
        data: 'FieldworkOfficeName',
        minWidth: 50,
      },
      { label: 'FW Fee', orderById: 'GeneralFieldWorkFee', data: 'GeneralFieldWorkFee', minWidth: 80 },
      {
        label: 'Evaluator',
        orderById: 'TpEvaluatorFullName',
        data: 'TpEvaluatorFullName',
        minWidth: 50,
      },
      {
        label: 'Status',
        orderById: 'ThirdPartyJobStatus',
        data: TpJobItem.getStatusCellContent,
        minWidth: 30,
      },
      {
        label: 'Completed On',
        orderById: 'JobDate',
        data: 'JobDate',
        minWidth: 50,
      },
      {
        label: 'Country',
        orderById: 'ThirdPartyLocationCountry',
        data: 'ThirdPartyLocationCountry',
        minWidth: 50,
      },
      {
        label: 'Uninvoiceable',
        orderById: 'IsUninvoiceable',
        data: 'IsUninvoiceable',
        minWidth: 20,
      },
      {
        label: 'Paid Outside of System',
        orderById: 'PaidOutsideOfSystem',
        data: (item) => JsxHelper.YesNo(item.PaidOutsideOfSystem),
        minWidth: 20,
      },
    ];
  }
}
